import React from 'react';
import { UserPlus, CreditCard, Send } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: UserPlus,
    title: 'Créez votre compte',
    description: 'Inscrivez-vous en quelques minutes avec vos informations professionnelles.'
  }, {
    icon: CreditCard,
    title: 'Créez votre carte Visa USD',
    description: 'Générez une ou plusieurs cartes Visa USD directement depuis votre compte pour vos paiements internationaux.'
  }, {
    icon: Send,
    title: 'Payez vos fournisseurs',
    description: 'Envoyez le paiement directement à vos fournisseurs en Chine, en Turquie et à Dubaï en toute sécurité.'
  }];
  return <section id="how-it-works" className="py-20 bg-muted/30" data-id="element-95">
      <div className="container mx-auto px-4 md:px-6" data-id="element-96">
        <div className="text-center mb-16" data-id="element-97">
          <h2 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl mb-4" data-id="element-98">
            Comment ça marche
          </h2>
          <p className="text-xl text-muted-foreground" data-id="element-99">En 3 étapes simples</p>
        </div>

        <div className="grid gap-8 md:grid-cols-3 relative" data-id="element-100">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-border -z-10" data-id="element-101" />

          {steps.map((step, index) => <div key={index} className="flex flex-col items-center text-center group" data-id="element-102">
              <div className="relative mb-6" data-id="element-103">
                <div className="flex h-24 w-24 items-center justify-center rounded-full bg-background border-2 border-border shadow-sm group-hover:border-primary/50 transition-colors" data-id="element-104">
                  <step.icon className="h-10 w-10 text-primary" data-id="element-105" />
                </div>
                <div className="absolute -top-2 -right-2 flex h-8 w-8 items-center justify-center rounded-full bg-primary text-primary-foreground font-bold text-sm" data-id="element-106">
                  {index + 1}
                </div>
              </div>
              <h3 className="text-xl font-bold text-foreground mb-3" data-id="element-107">
                {step.title}
              </h3>
              <p className="text-muted-foreground max-w-xs" data-id="element-108">
                {step.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}